// src/Components/ResetPassword/ResetPassword.jsx

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Input, Button, message, Typography } from 'antd';
import { LockOutlined, CheckCircleFilled } from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

const ResetPassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleReset = async (values) => {
    if (values.password !== values.confirm) {
      return message.error("Passwords do not match");
    }

    if (values.password.length < 6) {
      return message.error("Password must be at least 6 characters");
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://communityrishtey.in/reset-password-confirm/",
        {
          uid: uid,
          token: token,
          new_password: values.password,
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      message.success("✅ Password reset successfully!");
      setTimeout(() => navigate('/User_Login'), 2000);

    } catch (err) {
      console.error(err);
      const errMsg = err.response?.data?.error || "Failed to reset password";
      message.error(`❌ ${errMsg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fff5f7, #ffe4ec)',
      padding: 20
    }}>
      <div style={{
        maxWidth: 450,
        width: '100%',
        background: '#fff',
        borderRadius: 20,
        padding: 40,
        boxShadow: '0 20px 60px rgba(255,0,85,0.15)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 30 }}>
          <div style={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #ff0055, #ff4d88)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16
          }}>
            <LockOutlined style={{ fontSize: 32, color: '#fff' }} />
          </div>
          <Title level={3} style={{ margin: 0, color: '#1a0a10' }}>
            Reset Password
          </Title>
          <Text type="secondary">Enter your new password below</Text>
        </div>

        <Form layout="vertical" onFinish={handleReset}>
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              { required: true, message: 'Please enter new password' },
              { min: 6, message: 'Minimum 6 characters' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter new password"
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirm"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm password' }
            ]}
          >
            <Input.Password
              prefix={<CheckCircleFilled />}
              placeholder="Confirm new password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{
                background: 'linear-gradient(135deg, #ff0055, #ff4d88)',
                border: 'none',
                color: '#fff',
                borderRadius: 999,
                height: 50,
                fontWeight: 700,
                fontSize: 15,
                marginTop: 8
              }}
            >
              🔐 Reset Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;